import queryString from 'query-string';
import { apiFetch } from './utils/api';

// eslint-disable-next-line no-unused-vars
import { costReportMock } from '../store/entities/mocks/costReport';

export const costReports = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = queryString.stringify(args, { arrayFormat: 'comma' });
    const url = `/v2/qlik/cost-report?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
